import { useState, useCallback } from 'react';
import { flattenKeys } from '../utils';

export default function useErrorFields() {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const resetErrorField = useCallback((changedValue: Record<string, any>) => {
    const namePaths = flattenKeys(changedValue).map((i) => i.join('.'));

    setErrors((prev) => {
      const newErrors = { ...prev };
      namePaths.forEach((namePath) => {
        delete newErrors[namePath];
      });
      return newErrors;
    });
  }, []);

  return {
    errorFields: errors,
    setErrorFields: setErrors,
    resetErrorField,
  };
}
